// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"c8cb7666","453":"e4b04597","571":"ef1dc364","773":"5fe93de5","932":"5d8f1be4","983":"7820122e"}[chunkId] + ".chunk.js";
};